import ChangePasswordForm from './ChangePasswordForm';

export default ChangePasswordForm;


// WEBPACK FOOTER //
// ./src/components/forms/ChangePasswordForm/index.js